import classNames from "classnames";
import { useEffect, useState } from "react";
import { ArrowUp } from "react-bootstrap-icons";

import Button from "@/components/ui/buttons/button";

import styles from "./ScrollToTopButton.module.scss";

const SCROLL_OFFSET = 500;

function ScrollToTopButton() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const content = document.querySelector<HTMLElement>(".scrollbar");

    const handleScroll = () => {
      const scrollTop = (content && content.scrollTop) || window.scrollY;
      setShowButton(scrollTop > SCROLL_OFFSET);
    };

    window.addEventListener("scroll", handleScroll);
    if (content) content.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (content) content.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    const content = document.querySelector<HTMLElement>(".scrollbar");
    if (content && content.scrollTop > 0) {
      content.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Button
      variant="primary-alt"
      onClick={handleClick}
      className={classNames(
        "position-fixed m-4 rounded-circle d-flex align-items-center justify-content-center",
        styles.scrollToTopBtn,
        showButton && styles.visible
      )}
    >
      <ArrowUp size={24} />
    </Button>
  );
}

export default ScrollToTopButton;
